import { createRouter, createWebHashHistory } from 'vue-router'
import SimakatraLayout from '@/layouts/SimakatraLayout.vue'
import SimakatraView from '@/views/SimakatraView.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import DevLayout from '@/layouts/DevLayout.vue'
import PreviewView from '@/views/PreviewView.vue'
import EffectView from '@/views/EffectView.vue'

declare module 'vue-router' {
  interface RouteMeta {
    transition?: string
  }
}

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: SimakatraLayout,
      children: [
        {
          path: '',
          name: 'main',
          component: SimakatraView,
          meta: { transition: 'fade' },
        },
      ],
    },

    {
      path: '/dev',
      component: DevLayout,
      children: [
        {
          path: 'preview/:id?',
          name: 'preview',
          component: PreviewView,
          meta: { transition: 'fade' },
        },
        {
          path: 'effect',
          name: 'effect',
          component: EffectView,
          meta: { transition: 'fade' },
        },
      ],
    },

    // {
    //   path: '/',
    //   component: BlankLayout,
    //   children: [
    //     {
    //       path: 'home',
    //       name: 'home',
    //       component: () => import('../views/HomeView.vue'),
    //       meta: { transition: 'fade' },
    //     },
    //     {
    //       path: 'about',
    //       name: 'about',
    //       component: () => import('../views/AboutView.vue'),
    //       meta: { transition: 'fade' },
    //     },
    //   ],
    // }

    // module routes
  ],
})

export default router
